import { Container, SxProps, Theme } from "@mui/material";
import { ReactNode } from "react";
import { memberTheme } from "../memberTheme";

interface MainContainerProps {
  children: ReactNode;
  sx?: SxProps<Theme>;
}

function MainContainer({ children, sx }: MainContainerProps) {
  return (
    <Container
      sx={{
        backgroundColor: memberTheme.palette.greys.grey100,
        padding: "24px",
        borderRadius: "12px",
        ...sx,
      }}
    >
      {children}
    </Container>
  );
}

export { MainContainer };
